/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { authenticatedRequest } from '../common/authenticatedRequest';
import { callsClient } from './callsClient';
import { documentsClient } from './documentsClient';
import { notaryJournalClient } from './journalClient';
import { roomsClient } from './roomsClient';
import { authClient } from './authClient';
import { sessionsClient } from './sessionsClient';
import { usersClient } from './usersClient';
import { accountsClient } from './accountsClient';

const request = authenticatedRequest(() => {
  window.location.href = `/api/internal/auth/login?redirectUrl=${window.location.pathname}`;
});

export const notaryAPI = {
  auth: authClient(request),
  calls: callsClient(request),
  documents: documentsClient(request),
  journal: notaryJournalClient(request),
  rooms: roomsClient(request),
  sessions: sessionsClient(request),
  users: usersClient(request),
  accounts: accountsClient(request),
};
